import { Component } from "react";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import Loader from "../../../../utils/Loader";
import { ToastContainer, toast } from "react-toastify";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import { stallDesignRejectionReasonActionID, toastError, toastSuccess } from "../../../../utils/constants";
import { getStallDesignApprovalList_action, updateStallDesignApproval_action } from "../../../../actions/admin_module_action/manual_forms_admin_action/stallDesignApproval_action/stallDesignApproval_action";
import CommonModal from "../../../../utils/CommonModal";
import VendorDrawer from "../../../../common_components/vendor_module_drawer";
import { fill_action } from '../../../../actions/fillCombo_action';
import Modal from "react-modal";

class StallDesignApproval extends Component {

    //Initialized Constructor 
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            CompanyName: "",
            StallDesignApplicationList: [],
            RoleID: sessionStorage.getItem("RoleIDSS"),
            isViewModalOpen: false,
            selectedComponent: null,
            selectedId: null,
            stallDesignRejectionReasonList: [],
            filePath: '',
            fileName: '',
            displayfile: '',
            fileType: '',
            isOpen: false
        }
        this.getStallDesignAppliaction = this.getStallDesignAppliaction.bind(this)
        this.onCheckedAppliactions = this.onCheckedAppliactions.bind(this)
        this.onRemarkEnter = this.onRemarkEnter.bind(this)
        this.updateStallDesignApproval = this.updateStallDesignApproval.bind(this)
    }

    // On Component Load
    componentDidMount() {
        this.getFillList(stallDesignRejectionReasonActionID, '', '', '', '', '');
        this.props.location.state != null && this.props.location.state.companyName != "" && this.getStallDesignAppliaction(this.props.location.state.companyName)

        this.setState({
            CompanyName: this.props.location.state != null && this.props.location.state.companyName ? this.props.location.state.companyName : '',
        })
    }

    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props
            .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    if (actionID === stallDesignRejectionReasonActionID) {
                        this.setState({
                            stallDesignRejectionReasonList: data.data
                        })
                    }
                }
                this.setState({ isLoading: false })
            })
            .catch((e) => {
                console.log(e);
            });
    }

    // Get Exh Badges Appliactions
    getStallDesignAppliaction(companyname) {
        this.setState({ isLoading: true })
        this.props.getStallDesignApprovalList_action(companyname)
            .then((data) => {
                if (data.error != 1) {
                    console.log("getStallDesignAppliaction Data", data.data)
                    data.data.map((item) => {
                        item.isSelected = false;
                        item.isReadOnly = true;
                        item.Remarks = item.RejectReason;
                    })
                    this.setState({
                        StallDesignApplicationList: data.data,
                        isLoading: false
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    // On Check Exh Badge Applications
    onCheckedAppliactions(e) {
        const { StallDesignApplicationList } = this.state
        var checked = e.target.checked
        var id = e.target.value

        StallDesignApplicationList.length > 0 && StallDesignApplicationList.map((data) => {
            if (checked) {
                if (id == data.StallDesignFormID) {
                    data.isSelected = true;
                    data.isReadOnly = false
                }
            } else {
                if (id == data.StallDesignFormID) {
                    data.isSelected = false;
                    data.isReadOnly = true
                }
            }
        })
        this.setState({})
    }

    /// On Remark Enter
    onRemarkEnter(e, id) {
        const { StallDesignApplicationList } = this.state
        var value = e.target.value
        var list = [...StallDesignApplicationList]
        list.length > 0 && list.map((data) => {
            if (data.StallDesignFormID == id) {
                data.Remarks = value
            }
        })
        this.setState({ StallDesignApplicationList: list })

    }

    onStallDesignRejectionSelect(e, id) {
        const { StallDesignApplicationList } = this.state
        var value = e.target.value
        var list = [...StallDesignApplicationList]
        list.length > 0 && list.map((data) => {
            if (data.StallDesignFormID == id) {
                data.StallDesignRejectionReasonID = value
            }
        })
        this.setState({ StallDesignApplicationList: list })

    }

    onViewClick(ServiceName, id) {
        sessionStorage.setItem('ExhRegistrationIDSS', id.ExhRegistrationID)
        this.setState({
            isViewModalOpen: true,
            selectedComponent: ServiceName,
            selectedId: id,
        });
    }


    // On Update Visa Approval
    updateStallDesignApproval(e, key) {
        const { StallDesignApplicationList, CompanyName, filePath, fileName, fileType } = this.state
        var applicationList = StallDesignApplicationList.filter((item) => item.isSelected == true)
        if (applicationList.length == 0) {
            return toastError("Select Atleast One Application")
        }
        if (key == 1 && fileName == "") {
            return toastError("Please upload layout")
        }
        var list
        // checked Application List data Preparing to store
        var list = []
        applicationList.map(data => {
            var mapData = {
                'StallDesignFormID': parseInt(data.StallDesignFormID),
                'StallDesignRejectionReasonID': parseInt(data.StallDesignRejectionReasonID),
                "Remark": data.Remarks
            }
            list.push(mapData)
        });
        if (key == 2) {
            console.log("list---->", list)
            const isCheckedStallDesignRejectionReason = list.every(item => item.StallDesignRejectionReasonID)
            if (!isCheckedStallDesignRejectionReason) {
                return toastError("Please select Rejection Reason")
            }
            const isCheckedRemark = list.every(item => item.Remark != '' && item.Remark != null)
            if (!isCheckedRemark) {
                return toastError("Please Enter Remark")
            }
        }
        if (list.length > 0) {
            this.setState({ isLoading: true })
            this.props.updateStallDesignApproval_action(key == 1 ? true : false, list, false, filePath, fileName, fileType)
                .then((data) => {
                    if (data.error != 1) {
                        this.setState({ isLoading: false, isOpen: false })
                        toastSuccess(`Booth Stall Form ${key == 1 ? 'Approval' : 'Disapproval'} Successfully!`)
                        setTimeout(() => {
                            this.getStallDesignAppliaction(CompanyName)
                        }, 1000);
                    } else {
                        this.setState({ isLoading: false })
                        toastError(data.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        } else {
            toastError("Select Atleast One Application")
        }
    }

    onOpenPop() {
        const { StallDesignApplicationList } = this.state
        var applicationList = StallDesignApplicationList.filter((item) => item.isSelected == true)
        if (applicationList.length > 0) {
            this.setState({ isOpen: true })
        } else {
            toastError("Select Atleast One Application")
        }
    }

    onBackClick() {
        window.history.back()
    }

    shareStallDesignForm(e, key, StallDesignFormID, Remarks) {
        const { StallDesignApplicationList, CompanyName } = this.state
        var applicationList = StallDesignApplicationList.filter((item) => item.isSelected == true)
        var list
        // checked Application List data Preparing to store
        var list = []
        const mapData = {
            'StallDesignFormID': parseInt(StallDesignFormID),
            "Remark": Remarks
        }
        list.push(mapData)

        this.setState({ isLoading: true })
        this.props.updateStallDesignApproval_action(key == 1 ? true : false, list, true)
            .then((data) => {
                if (data.error != 1) {
                    this.setState({ isLoading: false })
                    toastSuccess(`Booth Design ${key == 1 ? 'Approval' : 'Disapproval'} Mail Shared Successfully!`)
                    setTimeout(() => {
                        this.getStallDesignAppliaction(CompanyName)
                    }, 1000);
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
            })
    }

    onFilePick = async (e, file) => {
        e.preventDefault();

        if (!file || file.length === 0) return;

        const selectedFile = file[0];

        // File size validation (max 5MB)
        if (selectedFile.size > 5 * 1024 * 1024) {
            toastError('File size more than 5MB is not allowed.');
            return;
        }

        // File type validation
        const fileName = selectedFile.name.toLowerCase();
        const allowedTypes = ['.jpeg', '.jpg', '.png'];

        const isValid = allowedTypes.some(ext => fileName.endsWith(ext));

        if (!isValid) {
            toast.error('Only .jpg, .jpeg, .png files are allowed.', {
                position: "top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
            });
            return;
        }

        // Convert file to Base64
        const image = await this.convertToBase64(selectedFile);

        const finalFileTypeName = selectedFile.type.split('/')[1] || '';

        this.setState({
            filePath: image,
            fileName: selectedFile.name,
            displayfile: image,
            fileType: finalFileTypeName,
        });
    };

    convertToBase64 = (file) => {
        return new Promise((resolve, reject) => {

            const reader = new FileReader()

            reader.readAsDataURL(file)

            reader.onload = () => resolve(reader.result)

            reader.onerror = error => reject(error)
        })
    }

    removeFile(e) {
        this.setState({ fileName: '', filePath: '', fileType: '', displayfile: '' })
    }

    handleViewFile = (base64String, fileName) => {
        // Extract MIME type and Base64 data
        const mimeType = base64String.split(";")[0].split(":")[1]; // Extract MIME type (e.g., 'image/png' or 'application/pdf')
        const byteCharacters = atob(base64String.split(",")[1]); // Extract Base64 content
        const byteNumbers = Array.from(byteCharacters).map((char) => char.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });

        // Create a URL for the Blob
        const fileURL = URL.createObjectURL(blob);

        if (mimeType.startsWith("image/") || mimeType === "application/pdf") {
            // Open viewable files directly
            const newTab = window.open(fileURL, "_blank", "noopener,noreferrer");
            if (newTab) {
                newTab.document.title = fileName; // Set the tab title to the file name
            }
        } else {
            // Download non-viewable files
            const link = document.createElement("a");
            link.href = fileURL;
            link.download = fileName; // Use the specific file name for the download
            link.click();
        }

        // Clean up the blob URL after the file action
        setTimeout(() => URL.revokeObjectURL(fileURL), 500);
    };

    render() {
        const { isLoading, StallDesignApplicationList, RoleID, isOpen, filePath, displayfile, fileName, fileType } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                {(RoleID == 7 || RoleID == 17) && <VendorDrawer />}
                {RoleID != 17 && RoleID != 7 && <AdminDrawer />}
                <div>
                    <>
                        <div className={"with-dr-container"}>
                            <div className="main-container" >
                                <div className="row m-0">
                                    <div className="breadcrumb-scroll-fixed">
                                        <h6 className="mb-0 py-2 text-white">
                                            Booth Design Approval</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="admin-top-space pt-2">
                                <div className="row mb-6 m-0">
                                    {/* <div className="col-lg-12 mt-2">
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label htmlFor="validationCustom03">Login Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                defaultValue="jindal rectifiers"
                                            />
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="validationCustom03">Badge Quota</label>
                                            <input type="text" className="form-control" />
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="validationCustom03">Balance Quota</label>
                                            <input type="text" className="form-control" />
                                        </div>
                                    </div>
                                </div> */}
                                    <div className="table-responsive">
                                        <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 ">
                                            <thead>
                                                <tr>
                                                    <th className="text-center">Sr.No</th>
                                                    <th className="text-center" >Select</th>
                                                    <th className="text-center">Company Name</th>
                                                    <th>Name</th>
                                                    <th className="text-center">Country</th>
                                                    <th className="text-center">Status</th>
                                                    <th className="text-center"
                                                        style={{ width: '300px' }}>Rejection Reason</th>
                                                    <th style={{ width: '600px' }}>Remarks</th>
                                                    <th className="text-center">View/Share</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    StallDesignApplicationList.length > 0 && StallDesignApplicationList.map((data, index) => (
                                                        <tr key={data.StallDesignFormID}>
                                                            <td className="text-center">{index + 1}</td>
                                                            <td className="text-center">
                                                                <input type="checkbox"
                                                                    checked={data.isSelected} value={data.StallDesignFormID}
                                                                    disabled={data.StatusID == "Approved" || data.StatusID == "Disapproved"}
                                                                    onChange={(e) => this.onCheckedAppliactions(e)}
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                {data.CompanyName}
                                                            </td>

                                                            <td>{data.Name}</td>
                                                            <td className="text-center">{data.Country}</td>
                                                            <td className="text-center">{data.StatusID}</td>
                                                            <td>
                                                                <select className="form-control"
                                                                    disabled={data.isReadOnly}
                                                                    value={data.StallDesignRejectionReasonID}
                                                                    onChange={(e) => this.onStallDesignRejectionSelect(e, data.StallDesignFormID)} >
                                                                    <option value={null}>Select</option>
                                                                    {
                                                                        this.state.stallDesignRejectionReasonList.length > 0 && this.state.stallDesignRejectionReasonList.map(data => (
                                                                            <option value={data.StallDesignRejectionReasonID} key={data.StallDesignRejectionReasonID}>{data.Description}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <form>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        style={{ height: 40 }}
                                                                        disabled={data.isReadOnly}
                                                                        value={data.Remarks}
                                                                        onChange={(e) => this.onRemarkEnter(e, data.StallDesignFormID)}
                                                                    />
                                                                </form>
                                                            </td>
                                                            <td className="text-center">
                                                                <i class="fa fa-eye grid-icon"
                                                                    onClick={(e) => this.onViewClick("Stall design", data)}>
                                                                </i> &emsp;
                                                                {(data.StatusID == "Approved" || data.StatusID == "Disapproved") &&
                                                                    <i class="fa fa-share grid-icon text-primary"
                                                                        onClick={(e) => this.shareStallDesignForm(e, data.StatusID == "Approved" ? 1 : 2, data.StallDesignFormID, data.Remarks)}
                                                                        title="Share mail again"
                                                                    >
                                                                    </i>
                                                                }
                                                            </td>
                                                        </tr>
                                                    ))
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="main-container mt-2">
                                        <div className="mt-1 mb-4 approval-actions">
                                            {StallDesignApplicationList.every(data => data.StatusID != "Approved" && data.StatusID != "Disapproved") &&
                                                <>
                                                    <a
                                                        className="btn btn-aqua"
                                                        type="submit"
                                                        onClick={() => this.onOpenPop()}
                                                    >
                                                        Approve
                                                    </a>
                                                    <a

                                                        className="btn btn-red m-1"
                                                        type="submit"
                                                        onClick={(e) => this.updateStallDesignApproval(e, 2)}
                                                    >
                                                        Reject
                                                    </a>
                                                </>}
                                            <a

                                                className="btn btn-gray m-1"
                                                type="submit"
                                                onClick={(e) => this.onBackClick()}
                                            >
                                                Back
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {/* <Modal
                            isOpen={isOpen}
                            shouldCloseOnEsc={true}
                            shouldCloseOnOverlayClick={true}
                            ariaHideApp={false}
                        >
                            <div className="modal-dialog modal-xl">
                                <div className="modal-content">
                                    <div className="modal-header text-white">
                                        <h6 className="modal-title">Please upload the allotted stall area</h6>
                                        <button type="button" className="btn-close btn-close-white" onClick={() => this.setState({ isOpen: false })} />
                                    </div>
                                    <div className="modal-body">
                                        <div className="row col-md-6">
                                            {fileName != "" ? (
                                                <>
                                                    <div className="d-flex" style={{ justifyContent: "center" }}>
                                                        <div className="chooseStallFile m-2">
                                                            <p className="overflow-membership m-0">{fileName}</p>
                                                            <span
                                                                className="membership_file_cross text-danger"
                                                                onClick={(e) =>
                                                                    this.removeFile(e, "file")
                                                                }
                                                            >
                                                                X
                                                            </span>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                <div className="d-flex" style={{ justifyContent: "center" }}>
                                                    <input
                                                        type="file"
                                                        accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                                        className="form-control mt-2"
                                                        onChange={(e) => this.onFilePick(e, e.target.files, "file")}
                                                    />
                                                </div>
                                            )}
                                            <p
                                                className="text-aqua"
                                                style={{ margin: "6px", textAlign: "center" }}
                                            >
                                                (Only .jpg, .jpeg, .png formats are allowed with maximum size of 5MB)
                                            </p>
                                        </div>
                                    </div>
                                    <div className="modal-footer">
                                        <button className="btn btn-aqua mx-2" onClick={(e) => this.updateStallDesignApproval(e, 1)}>
                                            Submit
                                        </button>
                                        <button className="btn btn-gray" onClick={() => this.setState({ isOpen: false })}>
                                            Close
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Modal> */}

                        <Modal
                            isOpen={isOpen}
                            shouldCloseOnEsc={true}
                            shouldCloseOnOverlayClick={true}
                            ariaHideApp={false}
                        >
                            <div className="modal-dialog modal-xl">
                                <div className="modal-content">

                                    <div className="modal-header text-white">
                                        <h6 className="modal-title">
                                            Please upload the allotted stall area
                                        </h6>

                                        <button
                                            type="button"
                                            className="btn-close btn-close-white"
                                            onClick={() => this.setState({ isOpen: false })}
                                        />
                                    </div>

                                    <div className="modal-body">

                                        <div className="row">
                                            <div className={fileName !== "" ? "col-md-6" : "col-md-12"}>
                                                {fileName !== "" ? (
                                                    <div
                                                        className="d-flex"
                                                        style={{ justifyContent: "center" }}
                                                    >
                                                        <div className="chooseStallFile m-2">
                                                            <p className="overflow-membership m-0"
                                                                onClick={() =>
                                                                    this.handleViewFile(
                                                                        this.state.filePath
                                                                    )
                                                                }
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                {fileName}
                                                            </p>

                                                            <span
                                                                className="membership_file_cross text-danger"
                                                                onClick={(e) =>
                                                                    this.removeFile(e, "file")
                                                                }
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                X
                                                            </span>
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <>
                                                        {/* Drag / Drop / Paste Area */}
                                                        <div
                                                            className="stall-file-drop-zone"
                                                            onDragOver={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                            }}
                                                            onDragEnter={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                e.currentTarget.classList.add(
                                                                    "drag-active"
                                                                );
                                                            }}
                                                            onDragLeave={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();
                                                                e.currentTarget.classList.remove(
                                                                    "drag-active"
                                                                );
                                                            }}
                                                            onDrop={(e) => {
                                                                e.preventDefault();
                                                                e.stopPropagation();

                                                                e.currentTarget.classList.remove(
                                                                    "drag-active"
                                                                );

                                                                const files = e.dataTransfer.files;

                                                                if (files && files.length > 0) {
                                                                    this.onFilePick(
                                                                        e,
                                                                        files,
                                                                        "file"
                                                                    );
                                                                }
                                                            }}
                                                            onPaste={(e) => {
                                                                const items =
                                                                    e.clipboardData?.items || [];

                                                                for (let i = 0; i < items.length; i++) {
                                                                    const item = items[i];

                                                                    if (
                                                                        item.kind === "file" &&
                                                                        item.type.startsWith("image/")
                                                                    ) {
                                                                        const file = item.getAsFile();

                                                                        if (file) {
                                                                            this.onFilePick(
                                                                                e,
                                                                                [file],
                                                                                "file"
                                                                            );
                                                                        }

                                                                        break;
                                                                    }
                                                                }
                                                            }}
                                                            tabIndex="0"
                                                        >
                                                            <div className="drop-content">

                                                                <div className="upload-icon">
                                                                    📁
                                                                </div>

                                                                <p className="mb-1">
                                                                    <strong>
                                                                        Drag & Drop your image here
                                                                    </strong>
                                                                </p>

                                                                <p className="text-muted mb-2">
                                                                    or press <b>Ctrl + V</b> to paste
                                                                    an image
                                                                </p>

                                                                <span className="text-muted">
                                                                    or
                                                                </span>

                                                                <div className="mt-2">
                                                                    <label
                                                                        htmlFor="stallFileInput"
                                                                        className="btn btn-aqua"
                                                                        style={{
                                                                            cursor: "pointer"
                                                                        }}
                                                                    >
                                                                        Choose File
                                                                    </label>

                                                                    <input
                                                                        id="stallFileInput"
                                                                        type="file"
                                                                        accept=".jpg,.jpeg,.png,image/jpeg,image/png"
                                                                        style={{
                                                                            display: "none"
                                                                        }}
                                                                        onChange={(e) =>
                                                                            this.onFilePick(
                                                                                e,
                                                                                e.target.files,
                                                                                "file"
                                                                            )
                                                                        }
                                                                    />
                                                                </div>

                                                            </div>
                                                        </div>

                                                        <p
                                                            className="text-aqua"
                                                            style={{
                                                                margin: "6px",
                                                                textAlign: "center"
                                                            }}
                                                        >
                                                            (Only .jpg, .jpeg, .png formats are allowed
                                                            with maximum size of 5MB)
                                                        </p>
                                                    </>
                                                )}

                                            </div>
                                        </div>
                                    </div>

                                    <div className="modal-footer">

                                        <button
                                            className="btn btn-aqua mx-2"
                                            onClick={(e) =>
                                                this.updateStallDesignApproval(e, 1)
                                            }
                                        >
                                            Submit
                                        </button>

                                        <button
                                            className="btn btn-gray"
                                            onClick={() =>
                                                this.setState({ isOpen: false })
                                            }
                                        >
                                            Close
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </Modal>

                    </>
                    <CommonModal
                        isOpen={this.state.isViewModalOpen}
                        componentName={this.state.selectedComponent}
                        componentProps={{
                            is_View: true,
                            FormID: this.state.selectedId,
                        }}
                        onClose={() => this.setState({ isViewModalOpen: false })}
                    />
                </div >

            </>
        )
    }
}
export default withRouter(connect(null, { getStallDesignApprovalList_action, updateStallDesignApproval_action, fill_action })(StallDesignApproval))